module.exports = __webpack_public_path__ + "static/media/logo-salute-e-societa.470bed59.png";